import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

const schema = z.object({
    FirstName: z.string().min(1, "FirstName is required"),
    LastName: z.string().min(1, "LastName is required"),
    Email: z.string().email("Valid Email is required"),
    Password: z
        .string()
        .optional()
        .refine((val) => !val || val.length >= 8, {
            message: "Password must be at least 8 characters long if provided",
        }),
});

const newUserResolver = zodResolver(schema);

export default newUserResolver;
